import { Axios } from "../../utils/axiosMiddleware";
import { setStripeConnectStatus } from "../../actions/StripeActions";
import { SimpleCatchError } from "../../utils/Helper";

/**
 * Stripe Connect payout status `{ payouts_enabled, charges_enabled,
 * details_submitted }` (snake_case). Dispatches it to Redux for the onboarding
 * screen and returns it so the charge gate can read a fresh value (payouts can be
 * disabled by Stripe KYC re-review after onboarding). Returns undefined on error.
 */
export const getConnectStatus = async (userId, dispatch) => {
  try {
    const response = await Axios.get(`stripe/connect/status/${userId}`);
    dispatch(setStripeConnectStatus(response?.data));
    return response?.data;
  } catch (e) {
    SimpleCatchError(e);
  }
};
